import ArrowLeft from '#components/svg/icons/ArrowLeft'
import React from 'react'
import PropTypes from 'prop-types'

function YearHeader({currentYear, increaseYear, decreaseYear}) {
  return (
    <div className="monthpicker__header">
      <div role="button" className="monthpicker__prev-year" tabIndex={0} onKeyDown={undefined} onClick={decreaseYear}>
        <ArrowLeft />
      </div>
      <div className="monthpicker__year">{currentYear}</div>
      <div role="button" className="monthpicker__next-year" tabIndex={0} onKeyDown={undefined} onClick={increaseYear}>
        <ArrowLeft />
      </div>
    </div>
  )
}

YearHeader.propTypes = {
  currentYear: PropTypes.number,
  increaseYear: PropTypes.func,
  decreaseYear: PropTypes.func,
}

export default YearHeader
